import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Filter, ShoppingCart } from 'lucide-react';
import { useCart } from '../../hooks/useCart';

const Header = ({ filters, onFilterChange, showFilters, onToggleFilters }) => {
  const { totalItems } = useCart();

  return (
    <header className="bg-pureWhite shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="glowgroove-logo.png" alt="GlowGroove" className="h-16 w-auto" />
            </Link>
          </div>
          
          <div className="flex-1 max-w-md mx-8">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slateText w-4 h-4" />
              <input
                type="text"
                placeholder="Search products..."
                value={filters.search}
                onChange={(e) => onFilterChange('search', e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-lightGray rounded-lg focus:outline-none focus:ring-2 focus:ring-pinkAccent focus:border-transparent"
              />
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <button
              onClick={onToggleFilters}
              className="bg-lightGray text-slateText px-4 py-2 rounded-lg hover:bg-gray-300 flex items-center"
            >
              <Filter className="w-4 h-4 mr-2" />
              Filters
            </button>

            {/* Cart Icon with Badge */}
            <Link 
              to="/cart" 
              className="relative p-2 text-slateText hover:text-pinkAccent transition-colors"
              aria-label="Shopping Cart"
            >
              <ShoppingCart className="w-5 h-5" />
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-pinkAccent text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;